module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "noindent_paraf"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("A well-driven train moving smoothly and strongly over a well-laid roadbed offers a traveler advantages and conveniences not to be had in any other form of transportation.")])]), _vm._v(" "), _c('p', {
    staticClass: "rightr"
  }, [_vm._v("E. B. White, “Progress and Change”")]), _vm._v(" "), _c('p', {
    staticClass: "common"
  }, [_c('img', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "alt": "",
      "src": "images/common.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85fbacc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Frontmatter06.vue
// module id = 102
// module chunks = 0